/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { SuppliersModel } from '../models';

export const ShuttleSuppliers: SuppliersModel[] = [
    <SuppliersModel>{
        vendorId: 5,
        title: 'Loadbalancer Enterprise',
        name: 'lbShuttleEnterprise',
        icon: 'brand-lb',
        description: 'adc_add_message_shuttle_enterprise',
        active: true,
        platforms: []
    },
    <SuppliersModel>{
        vendorId: 6,
        title: 'Loadbalancer Endurance',
        name: 'lbShuttleEndurance',
        icon: 'brand-lb',
        description: 'adc_add_message_shuttle_endurance',
        active: false,
        platforms: []
    },
    <SuppliersModel>{
        vendorId: 7,
        title: 'Standalone Shuttle',
        name: 'standaloneShuttle',
        icon: 'brand-lb',
        description: 'adc_add_message_shuttle_stand_alone',
        active: true,
        platforms: []
    },
    // <SuppliersModel>{
    //     vendorId: 10,
    //     title: 'Virtual Machine',
    //     name: 'vm',
    //     icon: 'brand-vm',
    //     description: 'adc_add_message_shuttle_virtual_machine',
    //     active: false,
    //     platforms: []
    // }
];
